import React from "react";
import { Row, Col } from "react-bootstrap";
import { Form, Field } from "react-final-form";
import { useMutation } from "@apollo/client";
import arrayMutators from "final-form-arrays";
import { FieldArray } from "react-final-form-arrays";

import Label from "../../reuseableComponents/label/Label";
import ButtonSubmit from "../../reuseableComponents/buttons/ButtonSubmit";
import ButtonProcessing from "../../reuseableComponents/buttons/ButtonProcessing";
import ButtonDelete from "../../reuseableComponents/buttons/ButtonDelete";
import ButtonBasic from "../../reuseableComponents/buttons/ButtonBasic";

import {
  ADD_DOC_TYPE,
  DELETE_DOC_TYPE,
  GET_DOC_TYPES,
  UPDATE_DOC_TYPE
} from "../../../queries/archiveQrys/secureQrys/fileUploadAdminQrys";

const DocumentTypesForm = ({
  user,
  item,
  setItem,
  setAdd,
  setSuccess,
  setError,
  submitError,
  submitting,
  setSubmitting
}) => {
  const [updateDocumentType] = useMutation(UPDATE_DOC_TYPE, {
    refetchQueries: [{ query: GET_DOC_TYPES }],
    awaitRefetchQueries: true
  });

  const [addDocumentType] = useMutation(ADD_DOC_TYPE, {
    refetchQueries: [{ query: GET_DOC_TYPES }],
    awaitRefetchQueries: true
  });

  const [deleteDocumentType] = useMutation(DELETE_DOC_TYPE, {
    refetchQueries: [{ query: GET_DOC_TYPES }],
    awaitRefetchQueries: true
  });

  const onDelete = (data) => {
    if (window.confirm(`Are you sure you want to delete ${data.label}?`)) {
      setSubmitting(true);
      deleteDocumentType({
        variables: data,
        onCompleted: (data) => {
          setItem(null);
          setSuccess("Record was successfully deleted.");
          //remove message after 4 seconds
          setTimeout(() => {
            setSuccess(null);
          }, 4000);
          setSubmitting(false);
        },
        onError: (error) => {
          setError(JSON.stringify(error.message));
          //remove message after 4 seconds
          setTimeout(() => {
            setError(null);
          }, 4000);
          setSubmitting(false);
        }
      });
    }
  };

  const onSubmit = (data, form) => {
    setSubmitting(true);
    if (item) {
      updateDocumentType({
        variables: { ...data, active: true },
        onCompleted: (data) => {
          form.reset();
          setItem(null);
          setSuccess("Record was successfully updated.");
          //remove message after 4 seconds
          setTimeout(() => {
            setSuccess(null);
          }, 4000);
          setSubmitting(false);
        },
        onError: (error) => {
          setError(JSON.stringify(error.message));
          //remove message after 4 seconds
          setTimeout(() => {
            setError(null);
          }, 4000);
          setSubmitting(false);
        }
      });
    } else {
      addDocumentType({
        variables: !data.subType ? { ...data, subType: [] } : data,
        onCompleted: (data) => {
          form.reset();
          setAdd(false);
          setSuccess("Record was successfully added.");
          //remove message after 4 seconds
          setTimeout(() => {
            setSuccess(null);
          }, 3000);
          setSubmitting(false);
        },
        onError: (error) => {
          setError(JSON.stringify(error.message));
          //remove message after 4 seconds
          setTimeout(() => {
            setError(null);
          }, 3000);
          setSubmitting(false);
        }
      });
    }
  };
  return (
    <>
      <Row>
        <Col>{item ? <h3 className='ms-4'>Update Document Type</h3> : <h3 className='ms-4'>Add Document Type</h3>}</Col>
      </Row>
      <Row>
        <Col>
          <Form
            onSubmit={onSubmit}
            keepDirtyOnReinitialize
            mutators={{
              ...arrayMutators
            }}
            initialValues={
              item
                ? {
                    recordId: item.value,
                    label: item.label,
                    updatedBy: user.email,
                    active: true, //SQL only pulls active doctypes
                    subType:
                      item.subType.length > 0
                        ? item.subType.map((sub) => ({
                            subtype: sub.subtype,
                            active: sub.active,
                            recordId: item.value,
                            updatedBy: user.email,
                            subtypeId: sub.subtypeId
                          })) //pass subtype id in as a hidden value for deletes
                        : []
                  }
                : { createdBy: user.email }
            }
            render={({
              handleSubmit,
              values,
              form: {
                mutators: { push, pop }
              }
            }) => (
              <form onSubmit={handleSubmit}>
                <Row className='ms-4'>
                  <Col>
                    <Label htmlFor='label' label='Document Type' required />
                    <Field name='label' component='input' className='form-control mb-4' />
                  </Col>
                </Row>
                {values.label ? (
                  <Row className='ms-4'>
                    <ButtonBasic
                      id='gray-primary'
                      onClick={() =>
                        push("subType", {
                          active: true,
                          recordId: item ? item.value : null,
                          createdBy: item ? item.createdBy : user.email,
                          updatedBy: user.email
                        })
                      }
                    >
                      Add Subtype (optional)
                    </ButtonBasic>
                  </Row>
                ) : (
                  ""
                )}
                <FieldArray name='subType'>
                  {({ fields }) =>
                    fields.map((name, index) => (
                      <Row key={`${name}.subtype`} className='ms-4'>
                        <Col>
                          <Label htmlFor='subtype-label' label='Subtype' />
                          <Field
                            name={`${name}.subtype`}
                            component='input'
                            className='form-control mb-4'
                            disabled={!fields.value[index].active}
                          />
                        </Col>
                        <Col lg={2} md={2} key={index} className='m-auto pt-2'>
                          <Label htmlFor='active-label' label='Active' style={{ display: "inlineBlock" }} />
                          <Field
                            name={`${name}.active`}
                            component='input'
                            type='checkbox'
                            className='big-checkbox d-inline m-2'
                          />
                        </Col>
                      </Row>
                    ))
                  }
                </FieldArray>
                <Row>
                  <Col className='ms-4'>
                    {submitting ? (
                      <ButtonProcessing id='ddw-primary' disabled />
                    ) : (
                      <>
                        <ButtonSubmit id='ddw-primary' />
                        {item ? <ButtonDelete disabled={submitting} onClick={() => onDelete(values)} /> : ""}
                      </>
                    )}
                  </Col>
                </Row>
              </form>
            )}
          />
        </Col>
      </Row>
    </>
  );
};

export default DocumentTypesForm;
